import projectsRoutingKeys from "Areas/Projects/routingKeys";
import documentTypeButtonGroupItems from "Areas/SharedFeatures/documentTypeButtonGroupItems";
import NavigationPath from "Areas/SharedFeatures/navigationPath";
import { routesAndPagesMap } from "Common/routingUtils";
import { ButtonWithTooltip } from "Components/button";
import ButtonGroup from "Components/buttonGroup";
import Close from "Components/close";
import classNames from "classnames";
import Tabs from "devextreme-react/tabs";
import compact from "lodash/compact";
import find from "lodash/find";
import map from "lodash/map";
import React, { useCallback, useMemo } from "react";
import { useResizeDetector } from "react-resize-detector";
import { READ_ONLY_MODE } from "../types/readOnlyMode";
import locale from "./actionPanel.locale";
import Styled, { SIZES } from "./actionPanel.styled";
const ADD_DOCUMENT_BTN_INFO = {
    id: -1,
    text: locale.CREATE_PROJECT
};
export default function ActionPanel(props) {
    const { width, ref: observableRef } = useResizeDetector();
    const tabsDataSource = useMemo(() => [
        ...compact(map(props.selectedDocumentIds, id => {
            const document = find(props.documents, ["Id", id]);
            return (document && {
                id: document.Id,
                text: document.Name
            });
        })),
        ADD_DOCUMENT_BTN_INFO
    ], [props.selectedDocumentIds, props.documents]);
    const activeDocument = useMemo(() => find(props.documents, ["Id", props.activeDocumentId]), [props.documents, props.activeDocumentId]);
    const path = useMemo(() => activeDocument
        ? compact([
            activeDocument.ProjectName && {
                title: activeDocument.ProjectName,
                href: routesAndPagesMap.getPath(projectsRoutingKeys.PROJECT_DETAILS, activeDocument.ProjectId)
            },
            {
                title: activeDocument.Name
            }
        ])
        : [], [activeDocument]);
    const itemRender = useCallback((data) => data.id === ADD_DOCUMENT_BTN_INFO.id ? (props.canEditDocuments && (React.createElement(Styled.TabAddBtn, { onClick: (evt) => {
            evt.stopPropagation();
            props.projectId &&
                props.onOpenDocumentCreatorPanel &&
                props.onOpenDocumentCreatorPanel(props.projectId);
        } },
        React.createElement("i", { className: "icon-add font-h3", title: data.title })))) : (React.createElement(Styled.TabItem, { active: props.activeDocumentId === data.id, onClick: (evt) => {
            evt.stopPropagation();
            props.onSetDocumentActive && props.onSetDocumentActive(data.id);
        } },
        React.createElement("div", { className: "text-overflow-ellipsis font-small" }, data.text),
        React.createElement(Close, { fontSize: 10, size: 16, animateHoverColor: true, onClick: evt => {
                evt.stopPropagation();
                props.onCloseDocument && props.onCloseDocument(data.id);
            } }))), [
        props.onCloseDocument,
        props.onSetDocumentActive,
        props.onOpenDocumentCreatorPanel,
        props.activeDocumentId,
        props.projectId
    ]);
    const handleItemClick = useCallback((itemData) => {
        if (itemData.key !== props.documentType)
            props.activeDocumentId &&
                props.onChangeDocumentType &&
                props.onChangeDocumentType(props.activeDocumentId, itemData.key);
    }, [props.activeDocumentId, props.documentType, props.onChangeDocumentType]);
    const handleChangeReadOnlyMode = useCallback(() => {
        activeDocument &&
            props.onSetReadOnlyMode &&
            props.onSetReadOnlyMode(activeDocument.Id, props.readOnlyMode !== READ_ONLY_MODE.READ_WRITE
                ? READ_ONLY_MODE.READ_WRITE
                : READ_ONLY_MODE.READ_ONLY);
    }, [activeDocument, props.readOnlyMode, props.onSetReadOnlyMode]);
    if (!props.projectId)
        return null;
    return (React.createElement("div", { className: classNames(props.className, ""), ref: observableRef },
        React.createElement(Tabs, { dataSource: tabsDataSource, hoverStateEnabled: false, focusStateEnabled: false, activeStateEnabled: false, itemRender: itemRender, selectedIndex: tabsDataSource.length - 1, keyExpr: "id", width: width, height: SIZES.TAB_HEIGHT, scrollByContent: true, showNavButtons: true, repaintChangesOnly: true, noDataText: "", className: "p-8-12" }),
        React.createElement(Styled.Navigation, { className: "pl-0_75 pr-0_75 border-bottom-gray-100" },
            React.createElement(NavigationPath, { path: path, height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT }),
            React.createElement(ButtonGroup, { height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT, items: documentTypeButtonGroupItems, selectedItemKey: props.documentType, onItemClick: handleItemClick }),
            React.createElement("div", { className: "grid-cols-auto justify-content-flex-end" }, Boolean(activeDocument) &&
                (props.readOnlyMode === READ_ONLY_MODE.READ_ONLY ||
                    props.readOnlyMode === READ_ONLY_MODE.READ_WRITE) && (React.createElement(ButtonWithTooltip, { height: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT, width: SIZES.NAVIGATION_PANEL_ITEMS_HEIGHT, className: "no-border bg-transparent", onClick: handleChangeReadOnlyMode, popoverContent: props.readOnlyMode === READ_ONLY_MODE.READ_ONLY
                    ? locale.SET_EDIT_MODE_HINT
                    : locale.SET_READONLY_MODE_HINT },
                React.createElement("i", { className: classNames(props.readOnlyMode === READ_ONLY_MODE.READ_ONLY ? "icon-eye" : "icon-pen", "font-h5 text-primary-500") })))))));
}
